import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import AdminTransactionTable from "../../components/tables/AdminTransactionTable";
import {
    adminAcceptTransactions,
    adminRejectTransactions,
    getAdminTransactions
} from "../../store/action/transaction";


const AdminOrder = () => {
    const { token } = isAuthenticated();
    const [ loading, setloading ] = useState(true)
    const [ transactions , setTransactions ] = useState([])

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await getAdminTransactions(token);
            if (res.success) {
                let transactions = res.transactions.sort((a, b) => {
                    var dateA = new Date(a.createdAt);
                    var dateB = new Date(b.createdAt);
                    return dateB - dateA;
                });
                setTransactions(transactions);
                setloading(false)
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
    };

    const onClickAccept = async (trxId) => {
        try {
            const res = await adminAcceptTransactions(trxId, token);
            if (res.success) {
                alert("Berhasil di update");
                window.location.reload()
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
    };

    const onClickReject = async (trxId) => {
        try {
            const res = await adminRejectTransactions(trxId, token);
            if (res.success) {
                alert("Berhasil di update");
                window.location.reload()
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
    };

    return (
        <div className="bg-white rounded shadow">
            <div className="p-4 d-flex justify-content-between">
                <h5>Semua Transaksi</h5>
            </div>
           <AdminTransactionTable
               data={transactions}
               loading={loading}
               onClickAccept={onClickAccept}
               onClickReject={onClickReject}
           />
        </div>
    )
};


export default AdminOrder;
